import { useCallback, useState, type ChangeEvent } from 'react';

import { useDebounce } from '@mint-lib/hooks';

export const useSearchValue = () => {
  const [value, setValue] = useState('');
  const debouncedValue = useDebounce(value, 1000);

  const onChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => setValue(target.value),
    [],
  );

  const onClear = useCallback(() => setValue(''), []);

  return { value, debouncedValue, onChange, onClear };
};
